import { SText } from "@/components/atoms";
import { MAX_LENGTH_TRUNCATED_TEXT } from "@/constants/number";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
const TruncatedText = ({
  text,
  maxLength = MAX_LENGTH_TRUNCATED_TEXT,
}: {
  text: string;
  maxLength?: number;
}) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  if (text.length <= maxLength)
    return <SText text={text} className="text-gray-700" />;

  return (
    <div className="text-gray-700">
      {isExpanded ? (
        <>
          {text}
          <button
            onClick={() => setIsExpanded(false)}
            className="text-blue-600 hover:text-blue-800 inline-block ml-1"
          >
            {t("expand_text.collapse")}
          </button>
        </>
      ) : (
        <>
          {text.slice(0, maxLength)}
          <span>...</span>
          <button
            onClick={() => setIsExpanded(true)}
            className="text-blue-600 hover:text-blue-800 inline-block"
          >
            {t("expand_text.expand")}
          </button>
        </>
      )}
    </div>
  );
};

export default TruncatedText;
